const carouselItems = [
  {
    title: '热血完结漫 · 一口气看到结局',
    desc: '那些年我们追过的热血漫终于全部完结了。从主角初出茅庐到最终决战封神，完整的故事线等你从头刷到尾。',
    tag: '热血战斗',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20scene%20inspired%20by%20Japanese%20manga%20art%20style%2C%20silhouettes%20of%20warriors%20in%20motion%20with%20dramatic%20warm%20orange%20and%20red%20energy%20effects%2C%20speed%20lines%2C%20cinematic%20composition%2C%20dark%20background%20with%20warm%20highlights%2C%20no%20text%2C%20artistic%20illustration&width=800&height=500&seq=carousel-manga-01&orientation=landscape',
  },
  {
    title: '恋爱甜漫完结季 · 糖分补给站',
    desc: '甜蜜又心动的校园恋爱、都市恋情全部完结收录。从初遇到告白再到婚后日常，完整糖分一次补足。',
    tag: '恋爱甜宠',
    img: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20manga%20art%20style%20scene%20with%20cherry%20blossom%20petals%20floating%2C%20warm%20pink%20and%20peach%20tones%2C%20school%20courtyard%20setting%20with%20soft%20sunlight%2C%20gentle%20atmosphere%2C%20illustration%20style%2C%20no%20text%2C%20dreamy%20aesthetic&width=800&height=500&seq=carousel-manga-02&orientation=landscape',
  },
  {
    title: '悬疑推理完结篇 · 谜底全部揭晓',
    desc: '烧脑悬疑漫画全集在此，所有伏笔都已回收，所有谜团都已解开。推理迷不容错过的完结漫画完整版合集。',
    tag: '悬疑推理',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20atmospheric%20scene%20inspired%20by%20detective%20manga%2C%20dimly%20lit%20library%20with%20shafts%20of%20warm%20light%2C%20shadows%20and%20silhouettes%2C%20moody%20noir%20aesthetic%20with%20warm%20amber%20tones%2C%20illustration%20style%2C%20no%20text%2C%20suspenseful%20composition&width=800&height=500&seq=carousel-manga-03&orientation=landscape',
  },
  {
    title: '异世界轻改完结 · 穿越之旅终点站',
    desc: '异世界转生、游戏世界冒险等热门轻小说改编漫画全部完结。从穿越第一天到打倒魔王，完整旅程尽在迷妹漫画。',
    tag: '异世界冒险',
    img: 'https://readdy.ai/api/search-image?query=A%20fantasy%20world%20landscape%20inspired%20by%20isekai%20manga%20art%2C%20rolling%20green%20hills%20with%20a%20distant%20magical%20castle%2C%20warm%20golden%20sunset%20light%2C%20floating%20magic%20particles%2C%20adventure%20atmosphere%2C%20illustration%20style%2C%20no%20text%2C%20epic%20composition&width=800&height=500&seq=carousel-manga-04&orientation=landscape',
  },
  {
    title: '日常治愈完结 · 温暖你的每一天',
    desc: '轻松搞笑的日常系漫画全集完结收录。没有刀没有虐，只有让人会心一笑的温馨小故事，治愈你的每个疲惫时刻。',
    tag: '日常治愈',
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20slice%20of%20life%20manga%20style%20scene%2C%20warm%20cafe%20interior%20with%20soft%20sunlight%20through%20windows%2C%20plants%20on%20wooden%20shelves%2C%20comfortable%20atmosphere%2C%20gentle%20cream%20and%20beige%20tones%2C%20illustration%20style%2C%20no%20text%2C%20peaceful%20composition&width=800&height=500&seq=carousel-manga-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            完结漫画专题精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            五大热门品类完结漫画专题，每一部都是大结局已出的完整版
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}